export default {
  URL_LOGOUT_REDIRECT: '/',
  URL_LOGIN_REDIRECT: '/',
};
